import http from "@/settings/apiSettings"

class SicknessesDataService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/PER_Sicknesses", data)
    }
}
export default new SicknessesDataService()